import React from 'react';
import { useFilters } from '../hooks/use-filters';
import { DateSelector } from './date-selector';

export const EndDateSelector = () => {
    const {
        endDate,
        setEndDate
    } = useFilters();
    return (
        <DateSelector
            placeholder='End Date'
            value={endDate}
            onChange={setEndDate}
        />
    );
};
